<template>
    <teleport to="body">
        <transition enter-active-class="transition ease-out duration-200 transform" enter-from-class="opacity-0" enter-to-class="opacity-100" leave-active-class="transition ease-in duration-200 transform" leave-from-class="opacity-100" leave-to-class="opacity-0">
            <div ref="modal-backdrop" class="fixed inset-0 overflow-y-auto bg-black bg-opacity-50" v-show="showModal" style="z-index: 500;">
                <div class="flex items-start justify-center min-h-screen pt-24 text-center">
                    <div class="bg-white relative text-left overflow-hidden shadow-xl p-4 w-1/2" role="dialog" ref="modal" aria-modal="true" aria-labelledby="modal-headline">
                        <div v-if="headline" class="border-b p-4 -mt-4 -mx-4 mb-4">{{ headline }}</div>
                        <div class="cursor-pointer test-black absolute -top-1.5 right-0 py-2 px-2" @click.prevent="closeModal">
                            ×
                        </div>
                        <slot></slot>
                        <div class="text-right mt-2">
                            <base-button @click.prevent="closeModal">schließen</base-button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script>
import {ref, watch} from "vue";

import useClickOutside from "@/utils/clickOutside"

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        headline: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const showModal = ref(false);


        const modal = ref(null);
        const {onClickOutside} = useClickOutside();


        onClickOutside(modal, () => {
            if (showModal.value === true) {
                closeModal();
            }
        });

        function closeModal() {
            showModal.value = false;
        }

        watch(
            () => props.show,
            (show) => {

                console.log('show', show)
                //showModal.value = show;

                showModal.value = true
            }
        );

        return {
            closeModal,
            showModal,
            modal,
        };
    }
};
</script>

<style scoped>

</style>
